var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlumoBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1758",
    "data-name": "Group 1758",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.51,
    height: 22.457,
    viewBox: "0 0 22.51 22.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 22.51,
    height: 22.457,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M63.165,8.9a2.405,2.405,0,0,1,3.327-2.225,2.414,2.414,0,0,1,.781.522,2.407,2.407,0,0,1-1.233,4.063,2.405,2.405,0,0,1-2.691-1.439,2.409,2.409,0,0,1-.183-.921",
    transform: "translate(-49.444 -5.083)",
    fill: "#051b33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M22.51,11.2A11.255,11.255,0,1,1,0,11.2q0-.511.046-1.019T.185,9.167q.092-.5.229-.994T.732,7.2q.181-.477.4-.936t.487-.9q.264-.437.567-.848t.641-.794q.338-.382.71-.732t.773-.665q.4-.315.83-.592t.88-.514q.452-.238.923-.433T7.906.446q.487-.152.986-.259T9.9.018a2.224,2.224,0,0,1,1.721,3.9,2.222,2.222,0,0,1-.761.424,2.233,2.233,0,0,1-.428.092A6.8,6.8,0,0,0,5.414,7.722a6.894,6.894,0,0,0-.321.611,6.8,6.8,0,0,0,4.976,9.547,6.8,6.8,0,0,0,1.374.1,6.8,6.8,0,0,0,4.389-1.761,6.815,6.815,0,0,0,.921-1.025A6.8,6.8,0,0,0,17.89,12.7a6.8,6.8,0,0,0,.17-1.368,6.766,6.766,0,0,0-.02-.69,6.783,6.783,0,0,0-.248-1.356,2.209,2.209,0,0,1-.08-.429A2.223,2.223,0,0,1,17.979,7.6a2.223,2.223,0,0,1,3.922.045,2.224,2.224,0,0,1,.162.4A11.246,11.246,0,0,1,22.51,11.2",
    transform: "translate(0 0)",
    fill: "#051b33"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumoBtnIcon);
export default __webpack_public_path__ + "static/media/alumo-btn-icon.dcd075c12f9c3baaf129786206251452.svg";
export { ForwardRef as ReactComponent };